import { vasExpenseActions } from './vasExpenseActionCreator';

const initialState = {
  isLoading: false,
  dashBoardData: [],
  totalElements: 0,
  pageNumber: 0,
  pageSize: 10,
  addresses: [],
  vehicleNumber: null,
  vehicleType: null,
  cnSummaryData: null,
  receiptUrl: null,
  emailEvidenceUrl: null
};

const vasExpenseReducer = (state = initialState, action) => {
  switch (action.type) {
    case vasExpenseActions.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload
      };

    case vasExpenseActions.SET_LIST_DATA:
      return {
        ...state,
        isLoading: false,
        dashBoardData: action.payload.dashBoardData,
        totalElements: action.payload.totalElements,
        pageNumber: action.payload.pageNumber,
        pageSize: action.payload.pageSize
      };

    case vasExpenseActions.SET_ADDRESS_DETAILS:
      return {
        ...state,
        addresses: action.payload.addresses,
        vehicleNumber: action.payload.vehicleNumber,
        vehicleType: action.payload.vehicleType
      };

    case vasExpenseActions.SET_CN_SUMMARY:
      return {
        ...state,
        cnSummaryData: action.payload
      };

    case vasExpenseActions.UPDATE_PAGE_NUMBER:
      return {
        ...state,
        pageNumber: action.payload
      };

    case vasExpenseActions.SET_UPLOAD_URLS:
      return {
        ...state,
        ...action.payload
      };

    case vasExpenseActions.UPDATE_FORM_ADDRESSES:
      return {
        ...state,
        addresses: action.payload
      };

    case vasExpenseActions.RESET_FORM_DATA:
      return {
        ...state,
        addresses: [],
        vehicleNumber: null,
        vehicleType: null,
        cnSummaryData: null,
        receiptUrl: null,
        emailEvidenceUrl: null
      };

    default:
      return state;
  }
};

export default vasExpenseReducer;
